/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
//actions
import { getCheckInformation, uploadFile, discardFile } from 'state/actions/accountState/account_data';
// component
import Check from 'pages/dashboard/account/paymentinfo/selectmethod/check/check';



/* ========== ~~~~~~~~~~ CHECK : CONTAINER ~~~~~~~~~~ ========== */
const mapStateToProps = ({ accountData, sessionStatus }) => ({
    fields: accountData.CHECKS.fields,
    hasStoredData: !!Object.keys(accountData.CHECKS.storedData).length,
    generalStoredData: !!Object.keys(accountData.generalInformation.storedData).length,
    selectedPaymentType: accountData.selectedPaymentType,
    paymentUUID: accountData.paymentUUID,
    editable: accountData.CHECKS.editable,
    storedData: accountData.CHECKS.storedData,
    accountUUID: sessionStatus.accountUUID
});


// map actions
const mapDispatchToProps = dispatch => ({
    getCheckInformation: (hasStoredData, formName, accountUUID) => dispatch(getCheckInformation(hasStoredData, formName, accountUUID)),
    uploadFile: (file, formName) => dispatch(uploadFile(file, formName)),
    discardFile: (formName) => dispatch(discardFile(formName))
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Check);
